import React, { useEffect, useMemo } from 'react';

import {
  addThemeToConfiguration,
  loadConfiguration,
  reloadConfiguration,
} from 'common/actions/ideasConfiguration';
import connect from 'common/core/connect';

import type { IdeaTheme } from 'common/api/endpoints/idea';

type IdeasConfigurationContextValue = {
  addThemeToConfiguration: (theme: IdeaTheme) => Promise<void>;
  loadConfiguration: () => Promise<void>;
  reloadConfiguration: () => Promise<void>;
};

const notReady = () => Promise.reject(new Error('Ideas configuration context is not ready'));
export const IdeasConfigurationContext = React.createContext<IdeasConfigurationContextValue>({
  addThemeToConfiguration: notReady,
  loadConfiguration: notReady,
  reloadConfiguration: notReady,
});

type ConnectProps = {
  addThemeToConfiguration: (theme: IdeaTheme) => Promise<void>;
  loadConfiguration: () => Promise<void>;
  reloadConfiguration: () => Promise<void>;
};

type OwnProps = {
  children: React.ReactNode;
};

type Props = ConnectProps & OwnProps;

function IdeasConfigurationContainer({
  children,
  addThemeToConfiguration,
  loadConfiguration,
  reloadConfiguration,
}: Props) {
  useEffect(() => {
    loadConfiguration();
  }, [loadConfiguration]);

  const contextValue = useMemo(
    () => ({
      addThemeToConfiguration,
      loadConfiguration,
      reloadConfiguration,
    }),
    [addThemeToConfiguration, loadConfiguration, reloadConfiguration],
  );
  return (
    <IdeasConfigurationContext.Provider value={contextValue}>
      {children}
    </IdeasConfigurationContext.Provider>
  );
}

export default connect(null, {
  addThemeToConfiguration,
  loadConfiguration,
  reloadConfiguration,
})(IdeasConfigurationContainer) as unknown as React.FC<OwnProps>;
